

/// <reference path="EconomicEntity.ts" />

// Generated class InvitationResponsible_ManagedObject

class InvitationResponsible_ManagedObject extends EconomicEntity
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }
}
